import { PanelCategory, PanelConfig } from '@helios/panel-base'
import { RulesPanelComponent } from './lib/rules-panel.component'
import { RulesKey } from './panel-key'

export * from './lib/rules.module'
export * from './panel-key'

export const RulesPanelConfig: PanelConfig = {
  key: RulesKey,
  title: 'Rule Overview',
  description: 'View rules applied to an account ',
  category: PanelCategory.SUPPLEMENTARY,
  panelComponent: RulesPanelComponent,
  accessPermission: 'accessRuleOverviewPanel',
}
